module.exports = __webpack_public_path__ + "static/media/scadians.7bacaf52.jpg";